import { ModelBase, Property } from '@skylab-shared/core';

export class OrderDeliveryDimensionModel extends ModelBase {
	@Property()
	public height: number;

	@Property()
	public length: number;

	@Property()
	public weight: number;

	@Property()
	public width: number;
}
